import { createApp } from 'vue'
import { Store } from '../model/store/Store'
import { createRouter, createWebHashHistory } from 'vue-router';
import PuriNews from '../component/view/PuriNews.vue'
import PuriNewsDetail from '../component/pages/PuriNewsDetail.vue'
import ErrorNotFound from '../component/pages/ErrorNotFound.vue'
import {sendViewEvent} from "../util/Ga4EventUtil";

const unsavedPuriCount = document.getElementById('unsavedPuriCount').textContent
const latestImageId = document.getElementById('latestImageId').textContent.replace(/\s+/g, '')

const router = createRouter({
    history: createWebHashHistory(),
    routes: [
        {
            path: '/',
            name: 'root',
            component: ErrorNotFound,
            props: route => ({
                unsavedPuriCount: unsavedPuriCount,
                latestImageId: latestImageId
            })
        },
        {
            path: '/:id(\\d+)',
            component: PuriNewsDetail,
            props: route => ({
                unsavedPuriCount: unsavedPuriCount,
                latestImageId: latestImageId,
                id: Number(route.params.id)
            })
        },
        {
            path: '/:pathMatch(.*)*',
            redirect: { name: 'root' }
        }
    ]
});

router.afterEach((to,from) => {
    sendViewEvent(to.path)
})

const vue = createApp(PuriNews)
    .use(Store)
    .use(router)
    .mount('#puriNews');

export default vue
